// flow weak

import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  Row,
  Col,
  Checkbox,
  Button,
  FormGroup,
  FormControl,
  ControlLabel,
  InputGroup,
  Glyphicon,
  Image,
  Alert,
  Tabs,
  Tab,
  Table
} from "react-bootstrap";
import { connect } from "react-redux";
import { bindActionCreators, compose } from "redux";
import { createHashHistory } from "history";
import { withRouter, Link } from "react-router-dom";

import isEmpty from "lodash.isempty";
import Pagination from "react-paginating";
import NumberFormat from "react-number-format";
import "../dashboard/dashboard.scss";
import "react-responsive-tabs/styles.css";
import {
  userVoucherList,
  userOrderList,
  customerDetail,
  profileUpdate,
  changePassword,
  checkUserDeal,
  storeCredit,
  getSiteCity,
  userCoupanList,
  getRefferals,
  delteCard
} from "../../../redux/actions/frontActions";
import logo from "../../../img/ddb-logo.png";

import moment from "moment";
import { Notification } from "../../../components/notifications";
import { renderAlert, clearAlert } from "../../../redux/actions/alertsActions";
import CountryStateCity from "../../../components/countryStateCity/CountryStateCity";
import auth from "../../../services/auth";
import { appConfig } from "../../../config";
import { CopyToClipboard } from "react-copy-to-clipboard";
import DatePicker from "react-date-picker";
let Recaptcha = require("react-recaptcha");
let rand = require("random-key");
import Dialog from "react-bootstrap-dialog";

const history = createHashHistory();
let cart = "",
  isLoading = "false";
class MyAccount extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      headers: [
        { name: "Vouchers", tablink: "vouchers", isActive: true },
        { name: "Order History", tablink: "order-history", isActive: false }
      ],
      show: false,
      page: "",
      cityID: "",
      old_password: "",
      password: "",
      cpassword: "",
      totalRecords: 0,
      ctotalRecords: 0,
      currentPage: 1,
      ccurrentPage: 1,
      limit:25,
      currentOrderPage: "1",
      referral: "",
      copied: false,
      dealresponse: "",
      refferralresponse: "",
      userTypeID: "",
      disabled1: false,
      disabled2: false,
      referralStatus: false,
      hover: false,
      disabled: false,
      cityList:[],
      refferals: '',
      card_data: "",
      check_card: "",
      show: false,
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);

    this.handlePageChange = this.handlePageChange.bind(this);

    this.handleDismiss = this.handleDismiss.bind(this);
    this.handleShow = this.handleShow.bind(this);
    this.Clear = this.Clear.bind(this);

    this.handlePasswordSubmit = this.handlePasswordSubmit.bind(this);

    this.handleVoucherPageChange = this.handleVoucherPageChange.bind(this);
    this.handleOrderPageChange = this.handleOrderPageChange.bind(this);
    this.deleteCardDetail = this.deleteCardDetail.bind(this);
    this.handleShow = this.handleShow.bind(this);
  }


  handleShow() {
    this.setState({ show: true });
  }

  deleteCardDetail = (cardNumber) => {
    this.dialog.show({
      body: "Are you sure you want to delete this?",
      actions: [
        Dialog.CancelAction(),
        Dialog.OKAction(() => {
          this.confirmDelete(cardNumber);
          this.handleShow();
        })
      ]
    });
  }

  confirmDelete(cardNumber){
    let constData = {
      cardNumber: cardNumber,
      userID: localStorage.getItem('user_id'),
    }
    this.props.delteCard(constData);
  }

  onChangeStartDate = date => { this.setState({ dob: date, dobError: "" })};

  hoverOn = (e) => {
    this.setState({ hover: true, hoverID: e.target.attributes.getNamedItem("data-id").value });
  }

  hoverOff = (e) => { 
    this.setState({ hover: false, hoverID: e.target.attributes.getNamedItem("data-id").value });    
  }

  handleChange = e => {
    this.setState({ [e.target.name]: e.target.value });

    if (`${e.target.name}Error` !== "") {
      this.setState({ [`${e.target.name}Error`]: "" });
    }
    this.setState({ disabled1: false });
    this.setState({ disabled2: false });
  };

  handlePageChange = page => {
    this.setState({
      currentPage: page,
      ccurrentPage: page,
    });

    this.props.userVoucherList({ page: this.state.currentPage,limit: this.state.limit });
  };

  handleCoupanPageChange = page => {
    this.setState({
      ccurrentPage: page
    });
    const postData = {
      page: page,
      limit: this.state.limit,
      voucherType: "direct"
    };
    this.props.userCoupanList(postData);
  }

  handleVoucherPageChange = page => {
    this.setState({
      currentPage: page
    });
    const postData = {
      page: page,
      limit: this.state.limit
    };
    this.props.userVoucherList(postData);
  };

  handleOrderPageChange = page => {
    this.setState({
      currentOrderPage: page
    });

    this.props.userOrderList({ page: this.state.currentOrderPage });
  };

  handleDismiss() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }

  Clear() {}

  componentWillMount() {
    this.props.clearAlert();
    this.handleDismiss();
    this.props.checkUserDeal();
    this.props.storeCredit();
    this.handlePageChange(1);
    this.props.getSiteCity();

    const userinfo = auth.getUserInfo();
    let userID = userinfo.user_id !== "" ? userinfo.user_id : "";
    let url = appConfig.site.siteurl;
    let referral = url + "/#/referral/" + userID;
    this.setState({ referral: referral });

    let siteData = JSON.parse(localStorage.getItem('siteDDBStatus'));

    if(siteData){
      this.setState({ referralStatus: (siteData.referral_setting == 'disable') ? false : true, check_card: siteData.check_card })
    }


    if(this.props.themeData){
      if(this.props.themeData.button){
        this.setState({
          button_color: this.props.themeData.button.button_color,
          mouseover_color: this.props.themeData.button.mouseover_color,
        });
      }
    }

    if(this.props.themeData){
      if(this.props.themeData.button){
        this.setState({
          button_color: this.props.themeData.button.button_color,
          mouseover_color: this.props.themeData.button.mouseover_color,
        });
      }
    }
  }


  componentWillReceiveProps(nextProps) {
    if (this.props.card != nextProps.card) {
      if (nextProps.card) {
        this.props.clearAlert();
        this.handleShow();
        this.props.renderAlert("success", nextProps.card.message);
        isLoading = "true";
        this.props.storeCredit();
      }
    }

    if(nextProps.themeData){
      if(nextProps.themeData.button){
        this.setState({
          button_color: nextProps.themeData.button.button_color,
          mouseover_color: nextProps.themeData.button.mouseover_color,
        });
      }
    }

    if(this.props.refferals !== nextProps.refferals){
      if(nextProps.refferals){
        this.setState({refferals: nextProps.refferals.data});
        isLoading = "false";
      }
    }
    

    if (this.props.voucherList !== nextProps.voucherList) {
      if (nextProps.voucherList) {
        const setPageCount =
          nextProps.voucherList.total / nextProps.voucherList.per_page;
        this.setState({
          voucherList: nextProps.voucherList.data,
          totalRecords: nextProps.voucherList.total,
          perPage: nextProps.voucherList.per_page,
          pageCount: setPageCount
        });
        isLoading = "false";
      }
    }

    if (this.props.couponList !== nextProps.couponList) {
      if (nextProps.couponList) {
        const csetPageCount =
          nextProps.couponList.total / nextProps.couponList.per_page;
        this.setState({
          couponList: nextProps.couponList.data,
          ctotalRecords: nextProps.couponList.total,
          cperPage: nextProps.couponList.per_page,
          cpageCount: csetPageCount
        });
        isLoading = "false";
      }
    }

    if (this.props.orderList !== nextProps.orderList) {
      if (nextProps.orderList) {
        const setOrderPageCount =
          nextProps.orderList.total / nextProps.orderList.per_page;

        this.setState({
          orderList: nextProps.orderList.data,
          totalOrderRecords: nextProps.orderList.total,
          perOrderPage: nextProps.orderList.per_page,
          pageOrderCount: setOrderPageCount
        });
        isLoading = "false";
      }
    }

    if (this.props.custDetail !== nextProps.custDetail) {
      if (nextProps.custDetail) {
        this.setState({
          firstName: nextProps.custDetail.firstName,
          lastName: nextProps.custDetail.lastName,
          phone: nextProps.custDetail.phone,
          gender: nextProps.custDetail.gender,
          dob: (nextProps.custDetail.dob) ? new Date(moment(nextProps.custDetail.dob).format('YYYY-MM-DD')) : "",
          address1: nextProps.custDetail.address1,
          address2: nextProps.custDetail.address2,
          zipcode: nextProps.custDetail.zipcode,
          country: nextProps.custDetail.country,
          state: nextProps.custDetail.state,
          stateAbbr: nextProps.custDetail.stateAbbr,
          city: nextProps.custDetail.city,
          cityID: nextProps.custDetail.cityID,
          user_id: nextProps.custDetail.user_id,
          userTypeID: nextProps.custDetail.userTypeID
        });
        isLoading = "false";
      }
    }

    if (this.props.profileStatus != nextProps.profileStatus) {
      if (nextProps.profileStatus) {
        this.setState({ disabled1: false });
        this.props.clearAlert();
        this.handleShow();
        this.props.renderAlert("success", nextProps.profileStatus.message);
        isLoading = "false";
        this.Clear();
      }
    }

    if (this.props.passwordStatus != nextProps.passwordStatus) {
      if (nextProps.passwordStatus) {
        this.setState({ disabled2: false });
        this.props.clearAlert();
        this.handleShow();
        this.props.renderAlert("success", nextProps.passwordStatus.message);
        isLoading = "false";
        this.Clear();
      }
    }

    if (this.props.userdealResponse != nextProps.userdealResponse) {
      if (nextProps.userdealResponse) {
        this.setState({ dealresponse: nextProps.userdealResponse.response });
        this.setState({
          refferralresponse: nextProps.userdealResponse.refferral
        });
        if (nextProps.userdealResponse.response == "success") {
          this.props.storeCredit();
        }
      }
    }

    
    if (this.props.creditAmount != nextProps.creditAmount) {
      if (nextProps.creditAmount) { 
        isLoading = "false";       
        this.setState({ creditAmount: nextProps.creditAmount.data, card_data: nextProps.creditAmount.card_data });
      }
    }

    if (this.props.error != nextProps.error) {
      if (nextProps.error) {
        this.props.clearAlert();
        this.handleShow();
        this.props.renderAlert("warning", nextProps.error);
        isLoading = "false";
        this.setState({ disabled1: false });
        this.setState({ disabled2: false });
      }
    }

    if (nextProps.message) {
      this.handleShow();
      this.setState({
        alertMessage: nextProps.message,
        msgType: nextProps.alertType
      });
    }

    if(this.props.cityList != nextProps.cityList){
      if(nextProps.cityList){
        this.setState({cityList: nextProps.cityList.data});
      }
    }
  }

  componentWillUpdate(nextProps, nextState) {}

  validate = () => {
    let isError = false;
    const errors = {};

    if (!this.state.firstName) {
      isError = true;
      this.setState({ firstNameError: "red" });
    }

    if (!this.state.lastName) {
      isError = true;
      this.setState({ lastNameError: "red" });
    }

    if (!this.state.address1) {
      isError = true;
      this.setState({ address1Error: "red" });
    }

    if (!this.state.country) {
      isError = true;
      this.setState({ countryerror: "true" });
    }

    if (!this.state.state) {
      isError = true;
      this.setState({ stateerror: "true" });
    }
    if (!this.state.city) {
      isError = true;
      this.setState({ cityerror: "true" });
    }

    return isError;
  };

  passwordValidate = () => {
    let isError = false;
    const errors = {};

    if (!this.state.old_password) {
      isError = true;
      this.setState({ old_passwordError: "red" });
    }

    if (!this.state.password) {
      isError = true;
      this.setState({ passwordError: "red" });
    }

    if (this.state.password !== this.state.cpassword) {
      isError = true;
      this.setState({ cpasswordError: "red" });
    }

    return isError;
  };

  handlePasswordSubmit = e => {
    e.preventDefault();
    this.setState({ disabled: true });
    const err = this.passwordValidate();
    if (!err) {
      const formData = {
        userID: localStorage.getItem("user_id"),
        old_password: this.state.old_password,
        password: this.state.password
      };
      this.props.changePassword(formData);
    }
  };

  handleSubmit = e => {
    e.preventDefault();
    this.setState({ disabled: true });
    const err = this.validate();
    if (!err) {
      isLoading = "true";
      let formData = {
        id: this.state.user_id,
        firstName: this.state.firstName,
        lastName: this.state.lastName,
        phone: this.state.phone,
        gender: this.state.gender,
        dob: moment(this.state.dob).format('YYYY-MM-DD'),
        address1: this.state.address1,
        address2: this.state.address2,
        country: this.state.country,
        state: this.state.state,
        city: this.state.city,
        cityID: this.state.cityID,
        stateAbbr: this.state.stateAbbr,
        zipcode: this.state.zipcode,
        status: "Active",
        userTypeID: this.state.userTypeID
      };

      this.props.profileUpdate(formData);
    }
  };

  handleClipboard(e) {
    e.preventDefault();
  }

  onChange({ target: { value } }) {
    this.setState({ value, copu: false });
  }

  onCopy = e => {
    this.setState({
      copied: true,
      alertMessage: "Copied to clipboard!",
      msgType: "success",
      show: true
    });
    window.getSelection().toString();
  };

  handleTabs = (key) => {
    if(key === 1){
      isLoading = "true";
      this.props.userVoucherList({ page: this.state.currentPage,limit: this.state.limit });      
    }else if(key === 4){
      isLoading = "true";
      this.props.customerDetail(localStorage.getItem("user_id"));
    }else if(key === 2){
      isLoading = "true";
      this.props.userCoupanList({ page: this.state.ccurrentPage,limit: this.state.limit, voucherType: "direct" });
    }else if(key === 6){
      isLoading = "true";
      this.props.getRefferals();
    }else if(key === 7){
      isLoading = "true";
      this.props.userOrderList({ page: this.state.currentOrderPage,limit: this.state.limit });
    }
  }

  render() {
    let v = 1,
      o = 1;
    const { currentPage, totalRecords, perPage, pageCount, ccurrentPage, ctotalRecords, cperPage, cpageCount } = this.state;

    const {
      currentOrderPage,
      totalOrderRecords,
      perOrderPage,
      pageOrderCount
    } = this.state;

    return (
      <div>
        {isLoading == "true" ? (
          <div className="loader">
            <p className="loading-message">
              <i>Loading...</i>
            </p>
            <div className="spinner">
              <div className="dot1" />
              <div className="dot2" />
            </div>
          </div>
        ) : (
          ""
        )}
        <Dialog
          ref={el => {
            this.dialog = el;
          }}
        />
        <div className="container min-height">
            <header className="panel-heading">
            My Account
            {
              <span style={{float:"right"}}>
                {" "}
                Available Credit : ${this.state.creditAmount}{" "}
              </span>
            }
            </header>
            {this.state.show &&
              this.state.alertMessage !== "" && (
                <div className="col-lg-12">
                  <Alert
                    bsStyle={this.state.msgType}
                    onDismiss={this.handleDismiss}
                  >
                    <strong>{this.state.msgType}:</strong>{" "}
                    {this.state.alertMessage}
                  </Alert>
                </div>
              )}
            <div className="margin-top">
              <Tabs
                activeKey={this.state.key}
                onSelect={this.handleTabs}
                id="controlled-tab-example"
              >
                <Tab eventKey={1} title="Vouchers">
                  <Table striped bordered condensed hover>
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Merchant / Offer</th>
                        <th>Expiration</th>
                        <th>Redeem Date</th>
                        <th>Redeem Value</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {!isEmpty(this.state.voucherList) ? (
                        this.state.voucherList.map((list, index) => (
                          <tr key={Math.random()}>
                            <td>{v++}</td>
                            <td>
                              <b>{list.merchantName}</b>
                              <br />
                              #{list.voucherNumber}
                              <br />
                              {list.dealText}
                            </td>
                            <td>
                              {moment(list.expiryDate).format("DD-MM-YYYY")}
                            </td>
                            <td>
                              {list.redeemed_at
                                ? list.redeemed_at
                                : "Not Redeemed"}
                            </td>
                            <td>${list.voucherValue}</td>
                            <td>
                              <Button
                                onClick={() =>
                                  history.push(`/voucher/${list.voucherID}`)
                                }
                              >
                                <i className="fa fa-print" /> Print
                              </Button>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="6">Data Not Found</td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                  <div className="text-center">
                    <Pagination
                      total={totalRecords}
                      limit={perPage}
                      pageCount={pageCount}
                      currentPage={currentPage}
                    >
                      {({
                        pages,
                        currentPage,
                        hasNextPage,
                        hasPreviousPage,
                        previousPage,
                        nextPage,
                        totalPages,
                        getPageItemProps
                      }) => (
                        <div className="pagination">
                          <button
                            {...getPageItemProps({
                              pageValue: 1,
                              onPageChange: this.handleVoucherPageChange
                            })}
                          >
                            first
                          </button>

                          {hasPreviousPage && (
                            <button
                              {...getPageItemProps({
                                pageValue: previousPage,
                                onPageChange: this.handleVoucherPageChange
                              })}
                            >
                              {"<"}
                            </button>
                          )}

                          {pages.map(page => {
                            let activePage = null;
                            if (currentPage === page) {
                              activePage = {
                                backgroundColor: "#ccc",
                                color: "#666"
                              };
                            }
                            return (
                              <button
                                key={page}
                                style={activePage}
                                {...getPageItemProps({
                                  pageValue: page,
                                  onPageChange: this.handleVoucherPageChange
                                })}
                              >
                                {page}
                              </button>
                            );
                          })}

                          {hasNextPage && (
                            <button
                              {...getPageItemProps({
                                pageValue: nextPage,
                                onPageChange: this.handleVoucherPageChange
                              })}
                            >
                              {">"}
                            </button>
                          )}

                          <button
                            {...getPageItemProps({
                              pageValue: totalPages,
                              onPageChange: this.handleVoucherPageChange
                            })}
                          >
                            last
                          </button>
                        </div>
                      )}
                    </Pagination>
                  </div>
                </Tab>
                <Tab eventKey={2} title="My Coupons">
                  <Table striped bordered condensed hover>
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Merchant / Offer</th>
                        <th>Expiration</th>
                        <th>Redeem Date</th>
                        <th>Redeem Value</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {!isEmpty(this.state.couponList) ? (
                        this.state.couponList.map((list, index) => (
                          <tr key={Math.random()}>
                            <td>{v++}</td>
                            <td>
                              <b>{list.merchantName}</b>
                              <br />
                              #{list.voucherNumber}
                              <br />
                              {list.dealText}
                            </td>
                            <td>
                              {moment(list.expiryDate).format("DD-MM-YYYY")}
                            </td>
                            <td>
                              {list.redeemed_at
                                ? list.redeemed_at
                                : "Not Redeemed"}
                            </td>
                            <td>${list.voucherValue}</td>
                            <td>
                              <Button
                                onClick={() =>
                                  history.push(`/voucher/${list.voucherID}`)
                                }
                              >
                                <i className="fa fa-print" /> Print
                              </Button>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="6">Data Not Found</td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                  <div className="text-center">
                    <Pagination
                      total={ctotalRecords}
                      limit={cperPage}
                      pageCount={cpageCount}
                      currentPage={ccurrentPage}
                    >
                      {({
                        pages,
                        currentPage,
                        hasNextPage,
                        hasPreviousPage,
                        previousPage,
                        nextPage,
                        totalPages,
                        getPageItemProps
                      }) => (
                        <div className="pagination">
                          <button
                            {...getPageItemProps({
                              pageValue: 1,
                              onPageChange: this.handleCoupanPageChange
                            })}
                          >
                            first
                          </button>

                          {hasPreviousPage && (
                            <button
                              {...getPageItemProps({
                                pageValue: previousPage,
                                onPageChange: this.handleCoupanPageChange
                              })}
                            >
                              {"<"}
                            </button>
                          )}

                          {pages.map(page => {
                            let activePage = null;
                            if (currentPage === page) {
                              activePage = {
                                backgroundColor: "#ccc",
                                color: "#666"
                              };
                            }
                            return (
                              <button
                                key={page}
                                style={activePage}
                                {...getPageItemProps({
                                  pageValue: page,
                                  onPageChange: this.handleCoupanPageChange
                                })}
                              >
                                {page}
                              </button>
                            );
                          })}

                          {hasNextPage && (
                            <button
                              {...getPageItemProps({
                                pageValue: nextPage,
                                onPageChange: this.handleCoupanPageChange
                              })}
                            >
                              {">"}
                            </button>
                          )}

                          <button
                            {...getPageItemProps({
                              pageValue: totalPages,
                              onPageChange: this.handleCoupanPageChange
                            })}
                          >
                            last
                          </button>
                        </div>
                      )}
                    </Pagination>
                  </div>
                </Tab>
                <Tab eventKey={7} title="Order Detail">
                  <Table striped bordered condensed hover>
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Merchant / Offer</th>
                        <th>Offer</th>
                        <th>Amount Charged</th>
                        <th>Credit Used</th>
                        <th>Placed On</th>
                      </tr>
                    </thead>
                    <tbody>
                      {!isEmpty(this.state.orderList) ? (
                        this.state.orderList.map((list, index) => (
                          <tr key={Math.random()}>
                            <td>{o++}</td>
                            <td>{list.firstName + " " + list.lastName}</td>
                            <td>{list.dealText}</td>
                            <td>${list.amount_charged - list.store_credit_used}</td>
                            <td>${(list.store_credit_used) ? list.store_credit_used : '0'}</td>
                            <td>
                              {moment(list.placed_on).format("DD-MM-YYYY")}
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="6">Data Not Found</td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                  <div className="text-center">
                    <Pagination
                      total={totalOrderRecords}
                      limit={perOrderPage}
                      pageCount={pageOrderCount}
                      currentPage={currentOrderPage}
                    >
                      {({
                        pages,
                        currentOrderPage,
                        hasNextPage,
                        hasPreviousPage,
                        previousPage,
                        nextPage,
                        totalPages,
                        getPageItemProps
                      }) => (
                        <div className="pagination">
                          <button
                            {...getPageItemProps({
                              pageValue: 1,
                              onPageChange: this.handleOrderPageChange
                            })}
                          >
                            first
                          </button>

                          {hasPreviousPage && (
                            <button
                              {...getPageItemProps({
                                pageValue: previousPage,
                                onPageChange: this.handleOrderPageChange
                              })}
                            >
                              {"<"}
                            </button>
                          )}

                          {pages.map(page => {
                            let activePage = null;
                            if (currentOrderPage === page) {
                              activePage = {
                                backgroundColor: "#ccc",
                                color: "#666"
                              };
                            }
                            return (
                              <button
                                key={page}
                                style={activePage}
                                {...getPageItemProps({
                                  pageValue: page,
                                  onPageChange: this.handleOrderPageChange
                                })}
                              >
                                {page}
                              </button>
                            );
                          })}

                          {hasNextPage && (
                            <button
                              {...getPageItemProps({
                                pageValue: nextPage,
                                onPageChange: this.handleOrderPageChange
                              })}
                            >
                              {">"}
                            </button>
                          )}

                          <button
                            {...getPageItemProps({
                              pageValue: totalPages,
                              onPageChange: this.handleOrderPageChange
                            })}
                          >
                            last
                          </button>
                        </div>
                      )}
                    </Pagination>
                  </div>
                </Tab>
                <Tab eventKey={4} title="Edit Profile" >
                  {/*****Start Form for user profile */}
                  <form onSubmit={this.handleSubmit}>
                    <Row>
                      <Col md={8} xs={12}>
                        <Row>
                          <Col md={6} xs={12}>
                            <FormGroup>
                              <ControlLabel>First Name </ControlLabel>
                              <FormControl
                                type="text"
                                value={(this.state.firstName) ? this.state.firstName : ''}
                                placeholder="First Name"
                                onChange={this.handleChange}
                                style={{
                                  borderColor: this.state.firstNameError
                                }}
                                name="firstName"
                                autoComplete="off"
                              />
                            </FormGroup>
                          </Col>

                          <Col md={6} xs={12}>
                            <FormGroup>
                              <ControlLabel>Last Name </ControlLabel>
                              <FormControl
                                type="text"
                                value={(this.state.lastName) ? this.state.lastName : ''}
                                placeholder="Last Name"
                                onChange={this.handleChange}
                                style={{
                                  borderColor: this.state.lastNameError
                                }}
                                name="lastName"
                                autoComplete="off"
                              />
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col md={6} xs={12}>
                            <FormGroup>
                              <ControlLabel>Phone </ControlLabel>
                              <NumberFormat
                                format="###-###-####"
                                mask="_"
                                className="form-control"
                                name="phone"
                                placeholder="Enter Phone Number"
                                value={this.state.phone}
                                onChange={this.handleChange}
                                autoComplete="off"
                                style={{ borderColor: this.state.phoneError }}
                              />
                            </FormGroup>
                          </Col>
                          <Col md={6} xs={12}>
                            <FormGroup>
                              <FormGroup controlId="gender">
                                <ControlLabel>Gender</ControlLabel>
                                <FormControl
                                  name="gender"
                                  style={{
                                    borderColor: this.state.genderError
                                  }}
                                  value={(this.state.gender) ? this.state.gender : ''}
                                  componentClass="select"
                                >
                                  <option value="Male">Male</option>
                                  <option value="Female">Female</option>
                                </FormControl>
                              </FormGroup>
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col md={6} xs={12}>
                            <FormGroup>
                              <ControlLabel>Date of Birth </ControlLabel><br/>
                              <DatePicker
                                onChange={this.onChangeStartDate}
                                value={(this.state.dob) ? new Date(moment(this.state.dob).format('YYYY-MM-DD')) : ""}
                                className={(this.state.dobError) ? "error" : ""}
                              />
                            </FormGroup>
                          </Col>
                          <Col md={6} xs={12}>
                            <FormGroup>
                              <ControlLabel>Address</ControlLabel>
                              <FormControl
                                type="text"
                                value={(this.state.address1) ? this.state.address1 : ''}
                                placeholder="Address 1"
                                onChange={this.handleChange}
                                style={{
                                  borderColor: this.state.address1Error
                                }}
                                name="address1"
                                autoComplete="off"
                              />
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col md={6} xs={12}>
                            <FormGroup>
                              <FormGroup controlId="addresss2">
                                <ControlLabel>Address 2</ControlLabel>
                                <FormControl
                                  type="text"
                                  value={(this.state.address2) ? this.state.address2 : ''}
                                  placeholder="Address 2"
                                  onChange={this.handleChange}
                                  name="address2"
                                  autoComplete="off"
                                />
                              </FormGroup>
                            </FormGroup>
                          </Col>
                          <Col md={6} xs={12}>
                            <FormGroup>
                              <FormGroup controlId="zip">
                                <ControlLabel>Zip Code</ControlLabel>
                                <FormControl
                                  type="text"
                                  value={(this.state.zipcode) ? this.state.zipcode : ''}
                                  placeholder="Zip Code"
                                  onChange={this.handleChange}
                                  name="zipcode"
                                  autoComplete="off"
                                />
                              </FormGroup>
                            </FormGroup>
                          </Col>
                        </Row>
                      </Col>
                      <Col md={4} xs={12}>
                        <FormGroup>
                          <FormGroup controlId="country">
                            <ControlLabel>Country</ControlLabel>
                            <FormControl
                              type="text"
                              value={(this.state.country) ? this.state.country : ''}
                              placeholder="Country"
                              onChange={this.handleChange}
                              name="country"
                              autoComplete="off"
                            />
                          </FormGroup>
                        </FormGroup>
                      </Col>
                      <Col md={4} xs={12}>
                        <FormGroup>
                          <FormGroup controlId="state">
                            <ControlLabel>State</ControlLabel>
                            <FormControl
                              type="text"
                              value={(this.state.state) ? this.state.state : ''}
                              placeholder="State"
                              onChange={this.handleChange}
                              name="state"
                              autoComplete="off"
                            />
                          </FormGroup>
                        </FormGroup>
                      </Col>
                      <Col md={4} xs={12}>
                      <FormGroup>
                        <ControlLabel>Subscriber City</ControlLabel>
                        <FormControl style={{borderColor:this.state.cityIDError}} componentClass="select" name="cityID" value={this.state.cityID} placeholder="select" onChange={this.handleChange}>
                            <option value="">Choose Region/City</option>
                            {(this.state.cityList) &&
                              this.state.cityList.map((data, index) =>
                                <optgroup key={'hcity'+index} label={data.country}>
                                  {(data.cities) &&
                                    data.cities.map((city, index) => 
                                      <option key={'hcityval'+index} value={city.cityID}>{city.title}</option>
                                    )
                                  }
                                </optgroup>
                              )
                            }
                        </FormControl>
                      </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col md={12} xs={12}>
                        <Button
                          bsStyle="success"
                          type="submit"
                          style={{backgroundColor: (this.state.hover && this.state.hoverID == 'register') ? this.state.mouseover_color : (this.state.button_color) ? this.state.button_color : '#77C84E' }}
                          data-id = {'register'}
                          onMouseEnter={this.hoverOn} 
                          onMouseLeave={this.hoverOff} 
                          disabled={this.state.disabled1}
                        >
                          Update
                        </Button>
                      </Col>
                    </Row>
                  </form>
                  <br/>
                  {(this.state.card_data !== '' && this.state.check_card == 1) &&
                  <Row>
                    <Col md={12} xs={12}>
                      <b>Saved Card Detail</b>
                    </Col>
                    <Col md={12} xs={12}>
                      <hr/>
                    </Col>
                    <Col md={12} xs={12}>
                      <Table striped bordered condensed hover>
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>Card Number</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {(this.state.card_data !== '' && this.state.check_card == 1) ? (
                            this.state.card_data.map((card, index) => (
                              <tr key={Math.random()}>
                                <td>{++index}</td>
                                <td>{'XXXXXXXXXXXX'+card.cardNumber.toString().substr(-4)}</td>
                                <td>
                                <Button
                                  style={{backgroundColor: (this.state.hover && this.state.hoverID == "trash") ? this.state.mouseover_color : this.state.button_color}}
                                  data-id = {"trash"}
                                  onMouseEnter={this.hoverOn} 
                                  onMouseLeave={this.hoverOff}
                                  bsStyle="danger"
                                  onClick = {this.deleteCardDetail.bind(
                                    this, card.cardNumber
                                  )}
                                >
                                  <i className="fa fa-trash" />
                                </Button>
                            </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="6">Data Not Found</td>
                            </tr>
                          )}
                        </tbody>
                      </Table>
                    </Col>
                  </Row>
                  }
                  {/*****End form for user profile*/}
                </Tab>
                <Tab eventKey={5} title="Change Password">
                  {/******Start Change Password********/}
                  <form onSubmit={this.handlePasswordSubmit}>
                    <Row>
                      <Col md={12} xs={12}>
                        <Row>
                          <Col md={4} xs={12}>
                            <FormGroup>
                              <ControlLabel>Old Password </ControlLabel>
                              <FormControl
                                type="password"
                                value={this.state.old_password}
                                onChange={this.handleChange}
                                name="old_password"
                                autoComplete="off"
                                style={{
                                  borderColor: this.state.old_passwordError
                                }}
                              />
                            </FormGroup>
                          </Col>

                          <Col md={4} xs={12}>
                            <FormGroup>
                              <ControlLabel>Password </ControlLabel>
                              <FormControl
                                type="password"
                                value={this.state.password}
                                onChange={this.handleChange}
                                name="password"
                                style={{
                                  borderColor: this.state.passwordError
                                }}
                                autoComplete="off"
                              />
                            </FormGroup>
                          </Col>
                          <Col md={4} xs={12}>
                            <FormGroup>
                              <ControlLabel>Confirm Password </ControlLabel>
                              <FormControl
                                type="password"
                                value={this.state.cpassword}
                                onChange={this.handleChange}
                                name="cpassword"
                                style={{
                                  borderColor: this.state.cpasswordError
                                }}
                                autoComplete="off"
                              />
                            </FormGroup>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                    <Row>
                      <Col md={12} xs={12}>
                        <Button
                          bsStyle="success"
                          type="submit"
                          style={{backgroundColor: (this.state.hover && this.state.hoverID == 'register') ? this.state.mouseover_color : (this.state.button_color) ? this.state.button_color : '#77C84E' }}
                          data-id = {'register'}
                          onMouseEnter={this.hoverOn} 
                          onMouseLeave={this.hoverOff} 
                          disabled={this.state.disabled2}
                        >
                          Update
                        </Button>
                      </Col>
                    </Row>
                  </form>
                  {/******End Change Password*****/}
                </Tab>
                {(this.state.referralStatus)&&
                  <Tab eventKey={6} title="Referral">
                    {/******Start Referral********/}
                    {this.state.refferralresponse == "notAvailable" ? (
                      <div>
                        <ControlLabel>
                          {" "}
                          Referral settings not available.{" "}
                        </ControlLabel>
                      </div>
                    ) : this.state.refferralresponse == "enable" ? (
                      <form onSubmit={this.handleClipboard}>
                        <Row>
                          {this.state.dealresponse == "failed" ? (
                            <div>
                              <ControlLabel>
                                {" "}
                                Please make a purchase to receive a referral link.{" "}
                              </ControlLabel>
                            </div>
                          ) : (
                            <Col md={12} xs={12}>
                              <Row>
                                <Col md={6} xs={12}>
                                  <FormGroup>
                                    <ControlLabel>
                                      {" "}
                                      Your referral link is{" "}
                                    </ControlLabel>
                                    <FormControl
                                      type="text"
                                      value={this.state.referral}
                                      //onChange={this.handleChange}
                                      onChange={({ target: { value } }) =>
                                        this.setState({ value, copied: false })
                                      }
                                      name="referral"
                                      autoComplete="off"
                                      readOnly
                                    />
                                  </FormGroup>
                                </Col>
                              </Row>
                              <Row>
                                <Col md={12} xs={12}>
                                  <CopyToClipboard
                                    text={this.state.referral}
                                    onCopy={this.onCopy.bind(this)}
                                  >
                                    <button>Copy</button>
                                  </CopyToClipboard>
                                </Col>
                              </Row>
                              <Row>
                                <Col md={12} xs={12}>
                                  <br/>
                                  <Table striped bordered condensed hover>
                                    <thead>
                                      <tr>
                                        <th>#</th>
                                        <th>Name</th>
                                        <th>Created On</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {!isEmpty(this.state.refferals) ? (
                                        this.state.refferals.map((data, index) => (
                                          <tr key={`refferal${index}`}>
                                            <td>{++index}</td>
                                            <td>
                                              {data.name}
                                            </td>
                                            <td>
                                              {data.createdon}
                                            </td>
                                          </tr>
                                        ))
                                      ) : (
                                        <tr>
                                          <td colSpan="3">Data Not Found</td>
                                        </tr>
                                      )}
                                    </tbody>
                                  </Table>
                                </Col>
                              </Row>
                            </Col>
                          )}
                        </Row>
                      </form>
                    ) : (
                      ""
                    )}
                    {/******End Referral*****/}
                  </Tab>
                }
              </Tabs>
            </div>
        </div>
      </div>
    );
  }
}

MyAccount.propTypes = {
  userVoucherList: PropTypes.func.isRequired,
  userOrderList: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  error: state.frontReducer.error,
  voucherList: state.frontReducer.voucherList,
  orderList: state.frontReducer.orderList,
  custDetail: state.frontReducer.custDetail,
  alertType: state.alertsReducer.alertType,
  message: state.alertsReducer.message,
  profileStatus: state.frontReducer.profileStatus,
  passwordStatus: state.frontReducer.passwordStatus,
  userdealResponse: state.frontReducer.userdealResponse,
  creditAmount: state.frontReducer.creditAmount,
  cityList: state.frontReducer.cityList,
  couponList: state.frontReducer.couponList,
  refferals: state.frontReducer.refferals,
  card: state.frontReducer.card,
});

export default compose(
  connect(mapStateToProps, {
    userVoucherList,
    renderAlert,
    clearAlert,
    userOrderList,
    changePassword,
    customerDetail,
    profileUpdate,
    checkUserDeal,
    storeCredit,
    getSiteCity,
    userCoupanList,
    getRefferals,
    delteCard
  })
)(MyAccount);



// WEBPACK FOOTER //
// ./src/app/views/frontend/user/MyAccount.js